import { Outlet } from "react-router-dom";
import styles from "./AdminLayout.module.scss";
import AdminSidebar from "../../components/Admin/Sidebar/Sidebar";
import "../../index.scss";

export default function AdminLayout() {
  return (
    <div className={styles.adminLayout}>
      <AdminSidebar />
      <div>
        <main className={styles.adminOutlet}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
